export default __webpack_public_path__ + "static/media/qa.9e01d2b5.svg";